import { useEffect, useState } from "react";
import { GAME_ORIGIN } from "./siteConfig";

// Jogadores de verdade que estão dentro do jogo agora (presença do servidor do jogo, sem bots).
// Uma única consulta compartilhada por toda a página: a cada 5 s (2 s enquanto estiver sem sinal), com limite de 2,5 s por tentativa.
const state = { online: null, status: "loading", history: [] };
const subs = new Set();
let timer = null;

const emit = () => subs.forEach((f) => f({ ...state, history: [...state.history] }));

async function poll() {
  try {
    const ctl = new AbortController(); const to = setTimeout(() => ctl.abort(), 2500);
    let r; try { r = await fetch(`${GAME_ORIGIN}/api/online`, { cache: "no-store", signal: ctl.signal }); } finally { clearTimeout(to); }
    const j = await r.json();
    if (j && j.ok) {
      state.online = j.online; state.status = "live";
      state.history = [...state.history, j.online].slice(-30);
    } else throw new Error("resposta inválida");
  } catch (e) {
    state.status = "offline"; state.online = null;
  }
  emit();
  if (subs.size) { clearTimeout(timer); timer = setTimeout(poll, state.status === "live" ? 5000 : 2000); }
}

export function useOnlinePlayers() {
  const [s, setS] = useState({ ...state, history: [...state.history] });
  useEffect(() => {
    subs.add(setS);
    if (!timer) { poll(); timer = setTimeout(() => {}, 0); } else setS({ ...state, history: [...state.history] });
    return () => { subs.delete(setS); if (subs.size === 0) { clearTimeout(timer); timer = null; } };
  }, []);
  return s;
}
